import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { LauncherPosition } from '../types';

interface FrontChatState {
  isInitialized: boolean;
  launcherVisible: boolean;
  windowOpen: boolean;
  unreadCount: number;
  initializationError: string | null;
  initializationStatus: 'idle' | 'initializing' | 'ready' | 'error';
  launcherPosition: LauncherPosition;
}

const initialState: FrontChatState = {
  isInitialized: false,
  launcherVisible: true,
  windowOpen: false,
  unreadCount: 0,
  initializationError: null,
  initializationStatus: 'idle',
  launcherPosition: {
    side: 'left',
    bottom: 3,
  },
};

const frontChatSlice = createSlice({
  name: 'frontChat',
  initialState,
  reducers: {
    setInitialized: (state, action: PayloadAction<boolean>) => {
      state.isInitialized = action.payload;
    },
    setLauncherVisible: (state, action: PayloadAction<boolean>) => {
      state.launcherVisible = action.payload;
    },
    openChatWindow: state => {
      state.windowOpen = true;
    },
    closeChatWindow: state => {
      state.windowOpen = false;
    },
    toggleChatWindow: state => {
      state.windowOpen = !state.windowOpen;
    },
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
    setInitializationStatus: (
      state,
      action: PayloadAction<'idle' | 'initializing' | 'ready' | 'error'>,
    ) => {
      state.initializationStatus = action.payload;
    },
    setInitializationError: (state, action: PayloadAction<string | null>) => {
      state.initializationError = action.payload;
    },
    setLauncherPosition: (state, action: PayloadAction<LauncherPosition>) => {
      state.launcherPosition = action.payload;
    },
  },
});

export const {
  setInitialized,
  setLauncherVisible,
  openChatWindow,
  closeChatWindow,
  toggleChatWindow,
  setUnreadCount,
  setInitializationStatus,
  setInitializationError,
  setLauncherPosition,
} = frontChatSlice.actions;

export const frontChatReducer = frontChatSlice.reducer;
export default frontChatReducer;
